import { connect, ConnectedProps } from 'react-redux';
import { ReportingParameters } from './components/ReportingParameters';
import { RootState } from 'src/store';
import { reportsMapDispatchToProps, reportsMapStateToProps } from 'src/features/clients/client/reportsV2/container';
import { createReportingParameter, ReportingParametersActionType, updateReportingParameter } from './store/thunks';
import { progressSelectorFactory } from 'src/common';
import { fetchAfsls } from '../store/thunks';
import { selectAfsls } from '../store/selectors';

const mapStateToProps = (state: RootState) => ({
  ...reportsMapStateToProps(state),
  createReportingParameterProgress: progressSelectorFactory([ReportingParametersActionType.CreateReportingParameter])(state),
  updateReportingParameterProgress: progressSelectorFactory([ReportingParametersActionType.UpdateReportingParameter])(state),
  afsls: selectAfsls(state),
});

const mapDispatchToProps = {
  ...reportsMapDispatchToProps,
  createReportingParameter,
  updateReportingParameter,
  fetchAfsls,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;

export const ReportingParametersContainer = connector(ReportingParameters);
